import Button from '@mui/material/Button';

interface Props {
  buttonText: string;
  disabled?: boolean;
  handleClick: (...args: any[]) => any;
  dataTestId?: string;
}

export const BaseChecklessPaymentsButton = ({
  buttonText,
  disabled,
  handleClick,
  dataTestId
}: Props) => (
  <Button
    disabled={disabled}
    onClick={handleClick}
    data-testid={dataTestId}
    sx={{ marginTop: '42px' }}
    size="fullWidth"
  >
    {buttonText}
  </Button>
);
